<template>
    <div >
        <div ref="pieChart" class="chart-container" style="height: 250px;margin-top: 15px;"></div>
    </div>
</template>
<script>
export default {
    props: {
        chartData: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {
        this.initChart()
    },
    methods: {
        initChart() {
            const myChart = echarts.init(this.$refs.pieChart)
          var   option = {
                title: {
                    text: 'Referer of a Website',
                    subtext: 'Fake Data',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 1048, name: 'Search Engine' },
                            { value: 735, name: 'Direct' },
                            { value: 580, name: 'Email' },
                            { value: 484, name: 'Union Ads' },
                            { value: 300, name: 'Video Ads' }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            myChart.setOption(option)
        }
    }
}
</script>
<style scoped>
.chart-container {
    width: 100%;
    background: #f9fafc;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}
</style>